/**
 * Helferlein um aus einer graphQl Query edges und nodes zu dekonstruiren
 */
export const withoutEdgesAndNodes = <T>(edges: { node: T }[]) =>
    edges.map(edge => edge.node);
